import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { TrustBadges } from './TrustBadges';
const faqs = [{
  question: '¿Cuándo recibo el acceso?',
  answer: 'Inmediatamente. Al completar tu orden, recibirás un correo electrónico con acceso instantáneo al Código Post-Ruptura para que puedas empezar a aplicar el protocolo hoy mismo.'
}, {
  question: '¿Funciona realmente en 72 horas?',
  answer: 'El dolor de una ruptura toma tiempo en sanar, pero la ansiedad aguda y la necesidad desesperada de contacto pueden neutralizarse en 72 horas aplicando las tácticas neuro-estratégicas correctas.'
}, {
  question: '¿Es solo para mujeres?',
  answer: 'Aunque el lenguaje está dirigido a la experiencia femenina, los principios psicológicos de desintoxicación de dopamina y recuperación de poder aplican para cualquier persona atravesando una ruptura.'
}, {
  question: '¿Qué formato tiene?',
  answer: 'Es un ebook digital en formato PDF de alta calidad, diseñado para ser leído en cualquier dispositivo (teléfono, tablet o computadora) con total privacidad.'
}];
export function PricingFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="pricing" className="py-32 px-6 bg-charcoal-light relative border-t border-gold/10" data-id="element-126">
      <div className="max-w-4xl mx-auto" data-id="element-127">
        {/* Pricing Anchor */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-24" data-id="element-128">
          <p className="font-sans text-gray-400 uppercase tracking-widest text-sm mb-6" data-id="element-129">
            Inversión en tu paz mental
          </p>
          <div className="flex flex-col items-center justify-center gap-2 mb-10" data-id="element-130">
            <span className="font-playfair text-3xl text-gray-600 line-through decoration-red-900/50" data-id="element-131">
              $29.990
            </span>
            <span className="font-playfair text-6xl md:text-8xl font-bold text-metallic-gold drop-shadow-lg" data-id="element-132">
              $14.990
            </span>
            <span className="font-sans text-sm text-gold/60 uppercase tracking-widest mt-1" data-id="element-133">
              Pesos Argentinos
            </span>
          </div>
          <a href="https://tutiendadigi.shop/cart/51868811428120:1" target="_blank" rel="noopener noreferrer" className="group relative inline-block px-10 sm:px-14 py-5 sm:py-6 btn-metallic-gold text-charcoal font-sans font-black text-base sm:text-lg tracking-widest rounded-md overflow-hidden transition-all hover:shadow-gold-glow-lg hover:scale-105 duration-300 shadow-lg shadow-gold/30 text-center" data-id="element-134">
            <div className="absolute inset-0 w-full h-full bg-white/25 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-135" />
            <span className="relative z-10" data-id="element-136">OBTÉN ACCESO INMEDIATO</span>
          </a>

          {/* Trust Badges */}
          <div className="mt-8" data-id="element-137">
            <TrustBadges data-id="element-138" />
          </div>
        </motion.div>

        {/* FAQ Accordion */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="space-y-4" data-id="element-139">
          <h3 className="font-playfair text-3xl text-white text-center mb-12" data-id="element-140">
            Preguntas Frecuentes
          </h3>

          {faqs.map((faq, index) => <div key={index} className="bg-card border border-white/5 rounded-sm overflow-hidden transition-colors hover:border-gold/20" data-id="element-141">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-8 py-6 flex items-center justify-between text-left focus:outline-none" data-id="element-142">
                <span className="font-playfair text-xl text-gray-200" data-id="element-143">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-144" />
              </button>

              <AnimatePresence data-id="element-145">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-146">
                    <div className="px-8 pb-6 font-sans text-gray-400 font-light leading-relaxed border-t border-white/5 pt-4" data-id="element-147">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </motion.div>
      </div>
    </section>;
}